import React from 'react';
import {Tag} from '@chakra-ui/react';
import {Status, StatusLabels} from '../../shared/enrichment';

const statusBadgeColors: Record<
  Status,
  {
    color: string;
    bgColor: string;
  }
> = {
  draft: {
    bgColor: 'kgray.200',
    color: 'kgray.400',
  },
  published: {
    bgColor: 'kgreen.50',
    color: 'kgreen.500',
  },
};

export const StatusBadge = ({status}: {status: Status}) => {
  return (
    <Tag
      color={statusBadgeColors[status].color}
      bgColor={statusBadgeColors[status].bgColor}
      textTransform="uppercase"
      fontSize="xs"
    >
      {StatusLabels[status]}
    </Tag>
  );
};
